import { Alert, Button, Card, CircularProgress, Dialog, InputAdornment, Paper, TextField, Typography } from '@mui/material'
import React, { Component } from 'react'
// import { connect } from 'react-redux';
// import { SENDERTYPE, addMessageListToCaseList, addMessageToCaseList, disableLoadOffset, increaseLoadOffset, setChatDialogOpen, setCurrentChatCaseIndex, setRoomJoinedForCaseIndex, setSupportCaseTableData, setSupportChatTabAreaLoading } from '../../../redux/supportSlice';
import SendIcon from '@mui/icons-material/Send';
import ConflictMessageDisplay from './ConflictMessageDisplay';
import { APIData } from '../../constants/APIAdresses';
import OrderSummary from './OrderSummary';
// import SupportMessageDisplay from './SupportMessageDisplay';
// import { io } from 'socket.io-client';
// import { getSupportMessages } from '../../../APIHelper';
// import "./chatDialog.css";
// import InfoTabContainer from '../ChatDialogInfoArea/InfoTabContainer';
// import { APIData } from '../../../constants/APIAdresses';

function PaperComponent(props) {
    return (
        <Paper
            style={{
                position: "absolute",
                bottom: 0,
                // left: "20vw",
                // right:"20vw",
                left: 0,
                right: 0,
                borderTopRightRadius: 20,
                borderTopLeftRadius: 20,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                maxWidth: "100vw",
                height: "70vh",
                margin: 0,
            }}
            {...props} />
    );
}


export class ConflictDialog extends Component {
    // chatContainerRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            msg: "",
            msgList: [],
            isLoading: false,
            sendingInProgress: false,
            orderData: {},
            orderLoading: false,
            conflictStatus: props.data?.status != null ? props.data?.status : "1",
        }

        this.testRf = React.createRef();
        this.loadInProgress=false;
        this.sendingInProgress=false;
        this.offsetMultiplier = 0;
        this.orderLoadInProgress=false;
    }
    loadMessages = () => {
        console.log("Loading messages for conflict: ", this.props.data.id);
        if(this.offsetMultiplier == -1){
            console.log("No more messages to load");
        }
        if(!this.loadInProgress && this.offsetMultiplier != -1){
            fetch(`${APIData.USER}/order/getConflictMessages/${this.props.data.id}?offsetMultiplier=${this.offsetMultiplier}`, {credentials: "include"})
            .then((response) => {
                if(this.state.msgList.length === 0){ // this would mean the first load
                    setTimeout(() => {
                        if(this.testRf.current){    
                            this.testRf.current.scrollTop = this.testRf.current.scrollHeight;
                        }
                    }, 150);
                } else { // this would mean we are loading more messages by hitting the top of the scroll area
                    this.testRf.current.scrollTop = 1; // this is just to be able to scroll more.
                }
                if(response.ok){
                    response.json().then((data) => {
                        if(data.length > 0){
                            data = data.reverse();
                            let myMsgList = [...data, ...JSON.parse(JSON.stringify(this.state.msgList))]
                            console.log("MSGLISTNEW: ",myMsgList)
                            this.setState({msgList: myMsgList});
                        } else {
                            this.offsetMultiplier = -1; // this would mean we have no more messages to load
                        }
                    }).catch(e => {
                        console.log("Error parsing JSON for Conflict (Dialog): ", e);
                    })
                }else {
                    console.log("Server Error while loading conflictMessages status: ",response.status);
                }
            }).catch(e => {
                console.log("Error while loading messages for conflict dialog: ",e);
            })
            this.offsetMultiplier+=1;
        }
    }
    componentDidUpdate(prevProps) {
        if(this.props.opened && !prevProps.opened){
            console.log("######## OPENING CONFLICT DIALOG #########");
            this.loadMessages();
            this.loadOrderData();
        }
        if(this.props.data?.status != prevProps.data?.status){
            this.setState({conflictStatus: this.props.data.status});
        }
    }
    sendMsg () {
        // /order/sendConflictMessage/:conflictId)
        console.log("Sending message: ", this.state.msg);
        if(this.state.msg.length > 0 && !this.sendingInProgress){
            this.setState({sendingInProgress: true});
            fetch(`${APIData.USER}/order/sendConflictMessage/${this.props.data.id}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    msg: this.state.msg
                })
            }).then((response) => {
                this.sendingInProgress = false;
                if(response.ok){
                        this.setState({msgList: [...this.state.msgList, {type:'2', message: this.state.msg, createDate: new Date().toISOString()  }], msg: "", sendingInProgress: false});
                        setTimeout(() => {
                            if(this.testRf.current){    
                                this.testRf.current.scrollTop = this.testRf.current.scrollHeight;
                            }
                        }, 150);
                }else {
                    console.log("Server Error while sending message status: ",response.status);
                    this.setState({sendingInProgress: false});
                }
            }).catch(e => {
                this.setState({sendingInProgress: false});
                this.sendingInProgress = false;
                console.log("Error while sending message for conflict dialog: ",e);
            })
        }
        console.log("SENDING MSG: ", this.state.msg);
    }
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (e.shiftKey) {
                // Let it insert newline
                return;
            } else {
                e.preventDefault(); // prevent newline
                this.sendMsg();
            }
        }
    };
    resetContentAndClose() {
        this.setState({ msg: "", msgList: [] });
        this.offsetMultiplier = 0;
        this.loadInProgress = false;
        this.props.close();
    }
    loadOrderData () {
        if(!this.orderLoadInProgress && this.props.data.orderId != null){
            this.orderLoadInProgress=true;
            this.setState({orderLoading: true })
            fetch(`${APIData.USER}/order/getWithPositions/${this.props.data.orderId}`, {credentials:"include"})
            .then(response => {
                this.orderLoadInProgress=false;
                if(response.ok){
                    response.json().then(myOrderData =>{
                        myOrderData.orderPositions = JSON.parse(myOrderData.orderPositions || '[]');
                        this.setState({orderData: myOrderData, orderLoading: false});
                    })
                }
            }).catch(e => {
                this.orderLoadInProgress=false;
                this.setState({orderLoading: false});
                console.log("Error while loading order data: ",e);
            })
        }
    }

    closeConflict(){
        fetch(`${APIData.USER}/order/${this.props.data.orderId}/closeConflict`, {credentials:"include"})
        .then(response => {
            if(response.ok){
                this.setState({conflictStatus: "2"});
                this.props.data.status = "2";
                this.resetContentAndClose();
            }else {
                console.log("Error while closing conflict: ", response.status);
            }
        }).catch(e => {
            console.log("Error while closing conflict: ", e);
        })
    }
    openConflict(){
        fetch(`${APIData.USER}/order/${this.props.data.orderId}/reopenConflict`, {credentials:"include"})
        .then(response => {
            if(response.ok){
                this.setState({conflictStatus: "1"});
                this.props.data.status = "1";
            }else {
                console.log("Error while closing conflict: ", response.status);
            }
        }).catch(e => {
            console.log("Error while closing conflict: ", e);
        })
    }
    
    render() {
        return (
            <Dialog PaperComponent={PaperComponent} onClose={() => { this.resetContentAndClose() }} open={this.props.opened}>
                <div style={{ display: "flex", width: "100%", height: "100%", backgroundColor: "#FEFEFE" }}>
                    <div style={{ width: "60%", paddingLeft: "2.5%", paddingRight: "2.5%", height: "100%", flexDirection: "column", display: "flex", }}>
                        <Typography style={{ textAlign: "center", marginTop: 10, marginBottom: 5, color: "#676767" }} fontSize="small">Konflikt #{this.props?.data?.id}</Typography>
                        <div className='chatContentArea' ref={this.testRf} onScroll={(evt) => { if (evt.target.scrollTop === 0 && this.state.msgList?.length > 0) { this.loadMessages() } }} style={{ flex: 1, padding: 10, overflowY: "scroll", msOverflowStyle: "none", scrollbarWidth: "none", marginBottom: 10, marginTop: 5, scrollBehavior: "smooth" }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                {this.state.isLoading &&
                                    <CircularProgress size={25} />
                                }
                            </div>
                            {this.state.msgList.map((msg, index) => {
                                return <ConflictMessageDisplay key={"SUPPORTMSG_" + index} data={msg} />
                            })}
                        </div>
                        <div style={{ height: 60 + (this.state.msg.split("\n").length >= 6 ? 120 : this.state.msg.split("\n").length * 20) , marginBottom: "2.5%", display: "flex", alignItems: "center", }}>
                            {this.state.conflictStatus === "1" ?
                                <TextField
                                placeholder="Nachricht eingeben..."
                                value={this.state.msg}
                                onChange={(e) => this.setState({ msg: e.target.value })}
                                onKeyDown={this.handleKeyDown}
                                style={{ width: '100%', backgroundColor: '#FEFEFE' }}
                                variant="outlined"
                                multiline
                                maxRows={6}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Button onClick={() => {this.sendMsg()}}>
                                                <SendIcon />
                                            </Button>
                                        </InputAdornment>
                                    )
                                }}
                            />
                                :
                                <Typography style={{ textAlign: "center", width: "100%", color: "#d14d4d", }}> Dieser Fall ist geschlossen und muss erneut geöffnet werden um die Konversation fortzuführen.</Typography>
                            }
                        </div>

                    </div>
                    <div style={{ width: "40%", padding:15,backgroundColor: "#F8F8F8", }}>
                        <div style={{ display: "flex", gap:15, flexDirection:"column", justifyContent: "center", alignItems: "center",  width: "100%", height: "100%",  }}>
                            <OrderSummary order={this.state.orderData} isLoading={this.state.orderLoading}/>
                            <Button onClick={() => { this.state.conflictStatus === "1" ? this.closeConflict() : this.openConflict() }} variant='contained' color={this.state.conflictStatus === "1" ? "primary" : "success"} style={{width:"100%"}}>{this.state.conflictStatus === "1" ? "Konflikt Schließen" : "Konflikt Öffnen"}</Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}
// function mapStateToProps(state) {
//     return {
//         chatOpened: state.support.chatDialogOpen,
//         chatData: state.support.activeCaseList[state.support.chatCaseIndex],
//         currentCaseIndex: state.support.chatCaseIndex,
//         tabAreaLoading: state.support.supportChatTabAreaLoading,
//         liveDataUpdate: state.support.liveDataUpdate,
//         supportCaseTableData: state.support.supportCaseTableData
//     }
// }
// function mapDispatchToProps(dispatch) {
//     return {
//         setSupportCaseTableData: (data) => {
//             dispatch(setSupportCaseTableData(data));
//         },
//         setSupportChatTabAreaLoading: (isActive) => {
//             dispatch(setSupportChatTabAreaLoading(isActive));
//         },
//         setRoomJoinedForCaseIndex: (index) => {
//             dispatch(setRoomJoinedForCaseIndex(index));
//         },
//         disableLoadOffset: (caseId) => {
//             dispatch(disableLoadOffset(caseId));
//         },
//         increaseLoadOffsetByCaseId: (caseId) => {
//             dispatch(increaseLoadOffset(caseId))
//         },
//         closeChat: () => {
//             dispatch(setCurrentChatCaseIndex(-1));
//             dispatch(setChatDialogOpen(false));
//         },
//         addMessageListToCaseList: (scid, msgList) => {
//             dispatch(addMessageListToCaseList({ scid: scid, msgList: msgList }));
//         },
//         addMessageToCaseList: (msgObj) => {
//             dispatch(addMessageToCaseList(msgObj))
//             // scid: 2, content: 'Hmmm hey wie gehts?', createdAt: '2023-10-16T14:21:38.058Z', senderType: '2'
//         },
//         // increaseUnreadItemsQty: (caseId) => {
//         //     dispatch(increaseUnreadItemsCountForCaseId(caseId));
//         // }
//         // updateMessages: () => {

//         // }
//     }
// }
// export default connect(mapStateToProps, mapDispatchToProps)(SupportChatDialog)
export default ConflictDialog;
